import { SvgProps } from './interface/SvgProps';

const SvgIndisponible = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    viewBox="0 0 65 65"
    {...props}
  >
      <circle cx={20} cy={20} r={7.333} fill="#E7E4D9" stroke="#fff" strokeWidth={2} />
      <path
        fill="#E7E4D9"
        d="M34.434 28.333a16.667 16.667 0 0 0-14.43-25l-.002 8.334a8.332 8.332 0 0 1 7.215 12.5l7.217 4.166ZM5.566 28.333a16.667 16.667 0 0 0 28.866.003l-7.216-4.168a8.334 8.334 0 0 1-14.433-.001l-7.217 4.166ZM20 3.333A16.667 16.667 0 0 0 5.564 28.33l7.218-4.165A8.334 8.334 0 0 1 20 11.667V3.333Z"
      />
    </svg>
  );
  
  export default SvgIndisponible;
